<template>
  <div :class="['axiome-logique-container', 'axiome-logique-all-value-from']">
    <!--Affichage OnProperty-->
    <div :class="['display-flew-column', { 'display-flew-column-level0': level0 }]">
      <PropertyValue :values="onPropertyLiterals" :leftMargin="false" :showLanguageBadge="showLanguageBadge"
        :isInLogicalAxiom="true" />
      <template v-if="onPropertyBlanknodes.length">
        <AttributeBlankNode :blankNodes="onPropertyBlanknodes" :leftMargin="false"
          :showLanguageBadge="showLanguageBadge" />
      </template>
    </div>


    <!--Affichage Operand-->
    <span :class="['axiome-logique-operand', ' ml-2', ' mr-2', { 'axiome-logique-operand-level0': level0 }]">only</span>
    <div :class="['display-flew-column', { 'display-flew-column-level0': level0 }]">
      <PropertyValue :values="allValuesFromLiterals" :leftMargin="false" :showLanguageBadge="showLanguageBadge"
        :isInLogicalAxiom="true" />
      <AttributeBlankNode :blankNodes="allValuesFromBlanknodes" :leftMargin="false" :braceDisplay="true"
        :showLanguageBadge="showLanguageBadge"
        :showFirstOperand="allValuesFromLiterals !== undefined && allValuesFromLiterals.length > 0" />
    </div>

  </div>
</template>

<script>
export default {
  name: "LogicalAxiomeAllValuesFrom",
  computed: {

    allValuesFromLiterals() {
      let result = [];
      this.allValuesFrom.forEach(element => {
        result.push(...element.literals);
      });
      return result;
    },
    allValuesFromBlanknodes() {
      let blankNodes = [];
      this.allValuesFrom.forEach(element => {
        blankNodes.push(...element.blankNodes);
      });
      return blankNodes;
    },
  },
  props: {
    level0: {
      type: Boolean,
      default: false
    },
    showLanguageBadge: {
      type: Boolean,
      default: false
    },
    allValuesFrom: {
      type: Array,
      default: () => []
    },
    onPropertyBlanknodes: {
      type: Array,
      default: () => []
    },
    onPropertyLiterals: {
      type: Array,
      default: () => []
    }
  }
}
</script>
